import Feathers from './feathers'

class ShortQC extends Feathers {
    getShortQCUrl (shortCode) {
        /*return this.request({
            url: `${ this.base.replace('/api', '') }pc2/c?c=${ shortCode }`,
            headers: {
                'statistics-script': 'disable'
            }
        })*/
        
        return new Promise(async (resolve,reject) => {
            let d =await this.request({
                //url: `${ this.base.replace('/api', '') }pc2/c?c=${ shortCode }`,
                url:`${this.base}resource/shorturi?shortCodes=${ shortCode }`
            });
            resolve(d.Data);
        });
    }
    getNewspaperQrUrl(id,pubdate)
    {
    	return `http://${window.location.host}/share/newspaper/detail?id=${id}&date=${pubdate}`;
    }
    getVideoQrUrl(id)
    {
        return `http://${window.location.host}/share/video/detail?id=${id}`;
    }
}

export default ShortQC
